var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSlashSolidB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.09116 0.802754C0.798664 0.578535 0.373976 0.630488 0.143351 0.914863C-0.0872736 1.19924 -0.033836 1.61213 0.258664 1.83635L16.9087 14.5238C17.2012 14.7481 17.6259 14.6961 17.8565 14.4117C18.0871 14.1274 18.0337 13.7145 17.7412 13.4903L14.7824 11.2371C15.8962 10.127 16.6499 8.88283 17.0296 7.99963C17.1224 7.78361 17.1224 7.54299 17.0296 7.32697C16.6105 6.3508 15.7302 4.92893 14.414 3.74221C13.0921 2.54455 11.2724 1.5383 8.99991 1.5383C7.08179 1.5383 5.48429 2.25744 4.23835 3.2008L1.09116 0.802754ZM6.2746 4.75119C6.99179 4.11408 7.95085 3.7258 8.99991 3.7258C11.2359 3.7258 13.0499 5.48947 13.0499 7.6633C13.0499 8.34416 12.8727 8.984 12.5605 9.54182L11.4749 8.71603C11.7112 8.1883 11.773 7.584 11.6099 6.98518C11.2977 5.85041 10.2655 5.08752 9.11804 5.04104C8.95491 5.03557 8.85929 5.20783 8.90991 5.36096C8.96898 5.53596 9.00273 5.72189 9.00273 5.91604C9.00273 6.19494 8.93523 6.45744 8.8171 6.68986L6.27741 4.75393L6.2746 4.75119ZM10.4905 11.3246C10.0293 11.5024 9.52585 11.6008 8.99991 11.6008C6.76398 11.6008 4.94991 9.83713 4.94991 7.6633C4.94991 7.47463 4.96398 7.29143 4.98929 7.11096L2.3371 5.07932C1.69585 5.89143 1.23741 6.7008 0.970227 7.32697C0.877414 7.54299 0.877414 7.78361 0.970227 7.99963C1.38929 8.9758 2.2696 10.3977 3.58585 11.5844C4.90773 12.7821 6.72741 13.7883 8.99991 13.7883C10.3443 13.7883 11.5284 13.4356 12.5493 12.8996L10.4905 11.3246Z",
    fill: "#B2B2B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    fill: "white",
    transform: "translate(0 0.66333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlashSolidB);
export default __webpack_public_path__ + "static/media/eye-slash-solid-b.e3a20c58555fccea7670abccbe772c95.svg";
export { ForwardRef as ReactComponent };